(function () {
  // mobile menu
  var tg = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (tg && nav) tg.addEventListener('click', function () { nav.classList.toggle('is-open'); });

  // header search toggle
  var st = document.querySelector('[data-search-toggle]');
  var sb = document.querySelector('[data-search-bar]');
  if (st && sb) st.addEventListener('click', function () {
    var open = sb.hasAttribute('hidden');
    if (open) { sb.removeAttribute('hidden'); var i = sb.querySelector('input[type=search]'); if (i) i.focus(); }
    else { sb.setAttribute('hidden', ''); }
    st.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  // collection sort
  var sort = document.querySelector('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sort.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  // product page
  document.querySelectorAll('[data-pdp]').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.getAttribute('data-thumb');
        slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
        thumbs.forEach(function (b) { b.classList.toggle('is-active', b === t); });
      });
    });

    var vEl = root.querySelector('[data-variants]');
    if (!vEl) return;
    var variants = JSON.parse(vEl.textContent);
    var selects = root.querySelectorAll('[data-option]');
    var idInput = root.querySelector('[data-variant-id]');
    var btn = root.querySelector('[data-add]');
    var price = root.querySelector('[data-price]');

    function update() {
      var chosen = [].map.call(selects, function (s) { return s.value; }).join('|');
      var v = variants.find(function (x) { return x.options.join('|') === chosen; });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available;
      btn.textContent = v.available ? 'Add to Cart' : 'Sold Out';
      price.innerHTML = (v.compare ? '<s>' + v.compare + '</s> ' : '') + '<span>' + v.price + '</span>';
      if (window.history && history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
  });
})();
